import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function PWAPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("gf_pwa_dismissed")) return;
    const handler = (e) => { e.preventDefault(); setDeferred(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    await deferred.userChoice;
    setShow(false);
  };
  const dismiss = () => { localStorage.setItem("gf_pwa_dismissed", "1"); setShow(false); };

  if (!show) return null;
  return (
    <div data-testid="pwa-install-banner" className="fixed inset-x-3 bottom-24 z-[60] mx-auto max-w-md rounded-2xl border border-brand/20 bg-white p-4 shadow-2xl md:bottom-6 animate-fade-up">
      <button onClick={dismiss} className="absolute right-3 top-3 text-slate-400"><X className="h-4 w-4" /></button>
      <div className="flex items-center gap-3">
        <img src="/icon-192.png" alt="" className="h-12 w-12 rounded-xl" />
        <div className="flex-1">
          <p className="font-head font-bold text-slate-900">Install Grofkart</p>
          <p className="text-xs text-slate-500">Get faster access to nearby stores and orders.</p>
        </div>
      </div>
      <div className="mt-3 flex gap-2">
        <button data-testid="pwa-install-btn" onClick={install} className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-brand py-2 text-sm font-bold text-white">
          <Download className="h-4 w-4" /> Install
        </button>
        <button onClick={dismiss} className="rounded-xl border border-slate-200 px-4 text-sm font-medium text-slate-600">Not now</button>
      </div>
    </div>
  );
}
